import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AddToCartAPI } from '../redux/actions/Cart/AddToCartAction';
import { clearSyncQueue } from '../redux/slices/Cart/CartSlice';
import { showErrorToast } from '../helpers/SweetAlert';

const CartSyncHandler = ({ token }) => {
    const dispatch = useDispatch();
    const syncQueue = useSelector(state => state.cart.syncQueue);

    useEffect(() => {
        if (syncQueue.length === 0) return;

        const syncCart = async () => {
            try {
                for (const item of syncQueue) {
                    await dispatch(AddToCartAPI(item));
                }

                dispatch(clearSyncQueue());
            } catch (err) {
                console.error("Failed syncing some items to backend:", err);
                showErrorToast(err)
                // Optionally retry or show a toast
            }
        };

        syncCart();
    }, [syncQueue, dispatch]);

    return null;
};

export default CartSyncHandler;
